import { useCallback, useState } from "react";
import { toast } from "react-toastify";

import { ManageService } from "../services/Services";

export const useLoginCryptofacil = () => {
    const [isLoadingLogin, setIsLoadingLogin] = useState(false);

    const loginAccountCryptofacil = useCallback(async email => {
        setIsLoadingLogin(true);
        try {
            const responseLoginCryptofacil = await ManageService.loginCryptofacil(email);

            console.log("responseLoginCryptofacil login hook", responseLoginCryptofacil);
            return responseLoginCryptofacil;
        } catch (error) {
            console.log("error login hook", error);
            toast.error(error.message);
        } finally {
            setIsLoadingLogin(false);
        }
    }, []);

    return { isLoadingLogin, loginAccountCryptofacil };
};
